<template>
  <div>
    <page-title-bar></page-title-bar>
    <app-section-loader :status="loader"></app-section-loader>
    <v-container fluid grid-list-xl pt-0>
      <page-tool-bar
          :loading="loader"
          show_search
          :search.sync="search"
      >
          <v-flex shrink>
              <div class="text-right">
                  <v-btn @click="dialog = !dialog" color="green" dark>
                      <v-icon small dark left>add_box</v-icon>
                      Tạo Phiếu Mới
                  </v-btn>
                  <v-btn @click="exportCSV" color="green" class="white--text">XUẤT EXCEL</v-btn>
                  <export-csv-button
                      :trigger="export_csv.trigger"
                      :title="export_csv.title"
                      :rows="export_csv.rows"
                  ></export-csv-button>
              </div>
          </v-flex>
      </page-tool-bar>
      <v-layout row wrap>
        <v-flex xs12>
          <v-data-table
            :headers="headers"
            :items="items"
            :loading="loader"
            :search="search"
            class="elevation-1"
            :rows-per-page-items="[10, 20, 50]"
          >
            <template slot="items" slot-scope="props">
                <td class="text-xs-left">
                    <v-btn icon small @click="openEditDialog(props.item)">
                        <v-icon color="primary">edit</v-icon>
                    </v-btn>
                </td>
                <td>{{ props.item.receipt_id }}</td>
                <td>{{ props.item.month }}</td>
                <td>{{ props.item.amount | formatNumber }}</td>
                <td>{{ props.item.adjustment_date | formatTimeServer }}</td>
                <td>{{ props.item.note }}</td>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>

    <dialog-tao-phieu-dieu-chinh-cong-no-loi-nhuan
        :dialog="dialog"
        :editingItem="editingItem"
        @changeDialogState="dialog = $event"
        @refresh="getData"
    ></dialog-tao-phieu-dieu-chinh-cong-no-loi-nhuan>
  </div>
</template>

<script>
import api from "Api";
import DialogTaoPhieuDieuChinhCongNoLoiNhuan from "Components/Phieu/DialogTaoPhieuDieuChinhCongNoLoiNhuan";
import ExportCsvButton from "Components/ExportExcel/ExportCsvButton";

export default {
  components: {
    DialogTaoPhieuDieuChinhCongNoLoiNhuan,
    ExportCsvButton
  },
  data() {
    return {
      loader: false,
      dialog: false,
      items: [],
      editingItem: null,
      search: "",
      export_csv: {
          trigger: false,
          title: "danh_sach_phieu_dieu_chinh",
          rows: []
      },
      headers: [
          { text: "Thao tác", value: "actions", sortable: false },
          { text: "Mã phiếu", value: "receipt_id", sortable: false },
          { text: "Tháng", value: "month", sortable: false },
          { text: "Số tiền", value: "amount", sortable: false },
          { text: "Ngày điều chỉnh", value: "adjustment_date", sortable: false },
          { text: "Ghi chú", value: "note", sortable: false },
      ]
    };
  },
  created() {
      this.getData();
  },
  methods: {
    async getData() {
        this.loader = true;
        try {
            const res = await api.findProfitDebtAdjustment();
            if (res.status === 200) {
                this.items = res.data;
            }
        } catch (e) {
            console.error(e);
        } finally {
            this.loader = false;
        }
    },
    openCreateDialog() {
        this.editingItem = null;
        this.dialog = true;
    },
    openEditDialog(item) {
        this.editingItem = item;
        this.dialog = true;
    },
    exportCSV() {
        if (!this.items.length) {
            swal.fire("Thông báo", "Không có dữ liệu để xuất", "warning");
            return;
        }
        
        this.export_csv.rows = this.items.map(item => ({
            "Mã phiếu": item.receipt_id,
            "Tháng": item.month,
            "Số tiền": item.amount,
            "Ngày điều chỉnh": this.$options.filters.formatTimeServer(item.adjustment_date),
            "Ghi chú": item.note
        }));
        this.export_csv.trigger = !this.export_csv.trigger;
    }
  },
};
</script>
